import type { SpaceType } from "@circle-react/types/Space";

import {
  isChatPostType,
  isCoursePostType,
  isEventPostType,
  isMembersPostType,
} from "./spaceTypePredicates";

interface NotificationVisibilityArgs {
  mobileNotificationsEnabled: boolean;
  postType: SpaceType;
}

export const shouldRenderNotificationField = ({
  mobileNotificationsEnabled,
  postType,
}: NotificationVisibilityArgs): boolean => {
  if (isCoursePostType(postType) || isMembersPostType(postType)) {
    return false;
  }
  if (isChatPostType(postType)) {
    return mobileNotificationsEnabled;
  }
  return true;
};

export const shouldRenderEventAutoRsvp = (postType: SpaceType): boolean =>
  isEventPostType(postType);
